import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/login/Login'
import Profile from '@/components/view/Profile'
import Dashboard from '@/components/view/Dashboard'
import Organizations from '@/components/view/Organizations'
import Navigation from '@/components/routing/navigation'
import Merchant from '@/components/view/Merchant'
import CashierLoyalty from '@/components/view/CashierLoyalty'
import Loyalty from '@/components/view/Loyalty'
import ProductCategory from '@/components/view/ProductCategory'
import ProductSubCategory from '@/components/view/ProductSubCategory'
import ProductSubSubCategory from '@/components/view/ProductSubSubCategory'
import ProductProperty from '@/components/view/ProductProperty'
import Products from '@/components/view/Products'
import ProductLoyalty from '@/components/view/ProductLoyalty'
import ProductMenuGroup from '@/components/view/ProductMenuGroup'
import ProductBrand from '@/components/view/ProductBrand'
import SpecialItem from '@/components/view/SpecialItem'
import SpecialGroup from '@/components/view/SpecialGroup'
import LegalBrandMenuGroup from '@/components/view/LegalBrandMenuGroup'
import LegalBrandCategory from '@/components/view/LegalBrandCategory'
import LegalBrand from '@/components/view/LegalBrand'
import ProductSale from '@/components/view/ProductSale'
import Lottery from '@/components/view/Lottery'
import LotteryMember from '@/components/view/LotteryMember'
import ProductLoyaltyPrize from '@/components/view/ProductLoyaltyPrize'
import RoleManagement from '@/components/view/RoleManagement'
import UserManagement from '@/components/view/UserManagement'
import ChangePassword from '@/components/view/ChangePassword'
import AppAccountManagement from '@/components/view/AppAccountManagement'
import QRGenerator from '@/components/view/QRGenerator'
import CardLoyalty from '@/components/view/CardLoyalty'
import NewApplication from '@/components/view/NewApplication'
import FinishedApplication from '@/components/view/FinishedApplication'
import Partner from '@/components/view/Partner'
import WhereToCollect from '@/components/view/WhereToCollect'
import ChargeOperation from '@/components/view/ChargeOperation'
import CartManagement from '@/components/view/CartManagement'
import ResetPassword from '@/components/view/ResetPassword'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: ResetPassword
    },
    {
      path: '/navigation',
      name: 'navigation',
      component: Navigation,
      children: [
         {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard
        },
        {
          path: '/organizations',
          name: 'organizations',
          component: Organizations
        },
        {
          path: '/merchant',
          name: 'merchant',
          component: Merchant
        },
        {
          path: '/cashierloyalty',
          name: 'cashierloyalty',
          component: CashierLoyalty
        },
        {
          path: '/productloyalty',
          name: 'productloyalty',
          component: ProductLoyalty
        },
        {
          path: '/productCategory',
          name: 'productCategory',
          component: ProductCategory
        },
        {
          path: '/productSubCategory',
          name: 'productSubCategory',
          component: ProductSubCategory
        },
        {
          path: '/productSubSubCategory',
          name: 'productSubSubCategory',
          component: ProductSubSubCategory
        },
        {
          path: '/productProperty',
          name: 'productProperty',
          component: ProductProperty
        },
        {
          path: '/products',
          name: 'products',
          component: Products
        },
        {
          path: '/productsale',
          name: 'productsale',
          component: ProductSale
        },
        //{
          //path: '/productLoyalty',
          //name: 'productLoyalty',
          //component: ProductLoyalty
        //},
        {
          path: '/productmenugroup',
          name: 'productmenugroup',
          component: ProductMenuGroup
        },
        {
          path: '/productbrand',
          name: 'productbrand',
          component: ProductBrand
        },
        {
          path: '/specialitem',
          name: 'specialitem',
          component: SpecialItem
        },
        {
          path: '/specialgroup',
          name: 'specialgroup',
          component: SpecialGroup
        },
        {
          path: '/legalbrandmenugroup',
          name: 'legalbrandmenugroup',
          component: LegalBrandMenuGroup
        },
        {
          path: '/legalbrandcategory',
          name: 'legalbrandcategory',
          component: LegalBrandCategory
        },
        {
          path: '/legalbrand',
          name: 'legalbrand',
          component: LegalBrand
        },
        {
          path: '/lottery',
          name: 'lottery',
          component: Lottery
        },
        {
          path: '/lotterymember',
          name: 'lotterymember',
          component: LotteryMember
        },
        {
          path: '/productloyaltyprize',
          name: 'productloyaltyprize',
          component: ProductLoyaltyPrize
        },
        {
          path: '/userManagement',
          name: 'userManagement',
          component: UserManagement
        },
          {
          path: '/roleManagement',
          name: 'roleManagement',
          component: RoleManagement
         },
          {
          path: '/changePassword',
          name: 'changePassword',
          component: ChangePassword
        },
        {
          path: '/appAccountManagement',
          name: 'appAccountManagement',
          component: AppAccountManagement
        },
        {
          path: '/qrGenerator',
          name: 'qrGenerator',
          component: QRGenerator
        },
        {
          path: '/cardLoyalty',
          name: 'cardLoyalty',
          component: CardLoyalty
        },
        {
          path: '/newApplication',
          name: 'newApplication',
          component: NewApplication
        },
        {
          path: '/finishedApplication',
          name: 'finishedApplication',
          component: FinishedApplication
        },
        {
          path: '/Partner',
          name: 'Partner',
          component: Partner
        },
        {
          path: '/WhereToCollect',
          name: 'WhereToCollect',
          component: WhereToCollect
        },
        {
          path: '/ChargeOperation',
          name: 'ChargeOperation',
          component: ChargeOperation
        },
        {
          path: '/CartManagement',
          name: 'CartManagement',
          component: CartManagement
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js